<div class="to-be-rectified-error-modal-container">
  <div class="to-be-rectified-error-modal-container__error">
    {{ title | translate }}
  </div>
  <div *ngIf="rfidScannerBulkMode" style="margin-top: -15px" class="to-be-rectified-error-modal-container__error">
    Please try scanning tags one by one
  </div>
  <div class="to-be-rectified-error-modal-container__content">
    <div *ngIf="errorTxt && failedEvents.length; else defaultTxt">
      <div class="to-be-rectified-error-modal-container__content-error-title">
        {{ errorTxt | translate }}
      </div>
      <ion-row>
        <li *ngFor="let item of errors" class="to-be-rectified-error-modal-container__content-error">
          {{ item }}
        </li>
      </ion-row>
    </div>
    <ng-template #defaultTxt>{{ 'input_app_common.defaultErrorMessage' | translate }}</ng-template>
  </div>
  <div class="to-be-rectified-error-modal-container__btn-container">
    <ui-custom-button
      [btnTxt]="
        hasAnyNonUndoEvent && appIdentifier === 'endline_qc_v2'
          ? ('input_app_common.sync' | translate)
          : ('input_app_common.okay' | translate)
      "
      (clickEvent)="dismissModal()"
    ></ui-custom-button>
  </div>
</div>
